import { PAGE_VISIT_EVENT } from 'constants/analyticEvents';
// import {
//   MENU_ID,
//   SUB_MENU_PATH,
// } from 'section/01_NavigationBarSection/constants/routeDetails';

const blockedUsers = [
  'abrvstele+12@gmail.com',
  'abhimanyu.jain@takeda.com',
  'hann.yew@takeda.com',
  'rui.moriyama@takeda.com',
  'jacob.dixon@takeda.com',
  'masha.hoffey@takeda.com',
  'blessy.mathew@takeda.com',
  'deepa.dand@takeda.com',
  'robert.mcgrady@takeda.com',
  'sai.maddikayala@takeda.com',
  'michelle.morgan@takeda.com',
  'phoebe.ling@takeda.com',
  'jairo.rodriguez@takeda.com',
  'jacklin.guerrier@takeda.com',
  'shanshan.guo@takeda.com',
  'manik.chhabra@takeda.com',
  'vrinda.pathak@takeda.com',
  'jonathan.hui@takeda.com',
  'dinesh.sakthivel@takeda.com',
  'ganapathy.ramalingam@takeda.com',
  'saisukanya.swamy@takeda.com',
  'vartika.pandya@takeda.com',
  'sapana.jadhav@takeda.com',
  'tanvi.arora@takeda.com',
  'chaithra.gs@takeda.com',
  'eugenie.jumaian@takeda.com',
  'takuma.sotodate@takeda.com',
  'jenni-montiel.featherstone@takeda.com',
  'samantha.ruhl1@takeda.com',
  'stephanie.poly@takeda.com',
  'stephen.cue@takeda.com',
];
const BLOCK_START_DATE = new Date('2025-08-08');

const divisionNames = ['R&D Data, Digital, and Technology'];
const departmentNames = [
  'GDO Business Analytics and Insights',
  'Development Systems and Digital Strategy',
  'User Enablement and Adoption',
];

class GoogleAnalytic {
  #trackingId = null;

  #isBlocked = false;

  constructor(trackingId, userId, division, department, isExternal) {
    const now = new Date();

    if (
      now >= BLOCK_START_DATE &&
      divisionNames.includes(division) &&
      isExternal
    ) {
      this.#isBlocked = true;
      return;
    }
    if (now >= BLOCK_START_DATE && departmentNames.includes(department)) {
      this.#isBlocked = true;
      return;
    }
    if (now >= BLOCK_START_DATE && blockedUsers.includes(userId)) {
      this.#isBlocked = true;
      return;
    }

    if (trackingId) {
      const DEBUG_MODE = process.env.REACT_APP_ANALYTIC_DEBUG_MODE || false;

      const gaTagManagerScript = document.createElement('script');
      this.#trackingId = trackingId;

      gaTagManagerScript.setAttribute(
        'src',
        `https://www.googletagmanager.com/gtag/js?id=${this.#trackingId}`,
      );

      document.head.appendChild(gaTagManagerScript);

      window.gtag('js', new Date());
      window.gtag('config', this.#trackingId, {
        user_id: userId,
        debug_mode: DEBUG_MODE,
        custom_map: {
          dimension2: 'page_path',
          dimension3: 'page_name',
          dimension4: 'user_group',
          dimension5: 'department',
        },
      });
    }
  }

  // #routeProcess = (path) => {
  //   let route = null;
  //   Object.values(MENU_ID).forEach((currentSection) => {
  //     SUB_MENU_PATH[currentSection].forEach((currentRoute) => {
  //       const routeRegex = new RegExp(currentRoute.path);
  //       if (path.match(routeRegex)) {
  //         route = currentRoute.pathname;
  //       }
  //     });
  //   });
  //   return route;
  // };

  sendGAPageVisit = (path, pageName, moduleName) => {
    if (this.#isBlocked) return;

    const pageVisitParams = {
      page_path: path,
      page_name: pageName,
      module_name: moduleName,
    };
    window.gtag('event', PAGE_VISIT_EVENT, pageVisitParams);
  };

  sendGAEvent = (eventName, eventParams = null) => {
    if (this.#isBlocked) return;

    if (eventParams === null) {
      window.gtag('event', eventName);
      return;
    }
    window.gtag('event', eventName, eventParams);
  };

  configurePageView = (title, path, location) => {
    if (this.#isBlocked) return;

    window.gtag('config', this.#trackingId, {
      page_title: title,
      page_path: path,
      page_location: location,
    });
  };

  setGAUserProperties = (userProperties) => {
    if (this.#isBlocked) return;

    window.gtag('set', 'user_properties', userProperties);
  };
}

export default GoogleAnalytic;
